/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
export enum SearchFields {
  ANY = 'any',
  ID = 'id',
  NAME = 'name',
  AIR_ID = 'airId',
  ESN = 'esn',
  ICCID = 'iccid',
  IMEI = 'imei',
  IMEI2 = 'imei2',
  MEID = 'meid',
  SERIAL_NUMBER = 'serialNumber',
  TYPE = 'typeId',
  CATEGORY = 'category',
  FIRMWARE_VERSION = 'firmwareVersion',
  CONFIG_VERSION = 'configVersion',
  SCRIPT_VERSION = 'scriptVersion',
  ID_REPORT_TIMESTAMP = 'idReportTimestamp',
  LAST_REPORT_DATE = 'lastReportedTime',
  STATUS = 'status',
  GROUPS = 'groupIds',
  APP_ID = 'appId',
  ARCHITECTURE = 'architecture',
  ANDROID_OS_VERSION = 'androidOSVersion',
  ASSET_NAME = 'asset.title',
  ACCOUNT_NAME = 'account.title',
  KERNEL_VERSION = 'kernelVersion',
  VBUS_STATUS = 'vbusEnabledStatus',
  VBUS_MODE = 'vbusMode',
  MDT = 'mdt',
  LMU = 'lmu',
  SENTINEL_ASSOCIATION = 'sentinelAssociation',
  USER_ESN_MOBILE_ID = 'userESN',
  JPOD_FIRMWARE = 'jpodFirmware',
  VBUS_DATABASE = 'vbusDatabase',
  JPOD_CONFIG = 'jpodConfig',
  ANDROID_MDT_FIRMWARE = 'androidMdtFirmware',
  BLE3_FIRWARE = 'ble3Firmware',
  VBU3_FIRWARE = 'vbu3Firmware',
  RADIO_FIRMWARE = 'radioFirmware'
};
  
export const DEFAULT_SMART_SEARCH_QUERY = `(${SearchFields.ID}:*)`;

export const DEFAULT_SEARCH_FIELDS = [
  SearchFields.ID,
  SearchFields.NAME,
  SearchFields.AIR_ID,
  SearchFields.ESN,
  SearchFields.ICCID,
  SearchFields.IMEI,
  SearchFields.MEID,
  SearchFields.SERIAL_NUMBER,
  SearchFields.TYPE,
  SearchFields.CATEGORY,
  SearchFields.FIRMWARE_VERSION,
  SearchFields.CONFIG_VERSION,
  SearchFields.SCRIPT_VERSION,
  SearchFields.ID_REPORT_TIMESTAMP,
  SearchFields.LAST_REPORT_DATE,
  SearchFields.STATUS,
  SearchFields.GROUPS,
  SearchFields.APP_ID,
  SearchFields.ARCHITECTURE,
  SearchFields.ANDROID_OS_VERSION,
  SearchFields.ASSET_NAME,
  SearchFields.ACCOUNT_NAME,
  SearchFields.KERNEL_VERSION
];

// Define the DDSAR Sentinel Tag type ...
export enum SentinelTags {
  PRIMARY = 'ddsar-primary',
  SECONDARY = 'ddsar-secondary'
};

export enum DeviceEditorTabs {
  DETAILS = 0,
  FILES = 1,
  SERVICES = 2,
  ID_REPORT = 3,
  HEALTH_EVENTS = 4,
  TELEMETRY_EVENTS = 5,
  SENTINEL_ASSOCIATION = 6,
  ALERT_HISTORY = 7,
  MANUFACTURING = 8,
  SHIPPING = 9,
  SCI_SETTINGS = 10,
  CARB = 11
};

export interface DeviceIdentifierDataType {
  label: string;
  value: string;
};

export enum CarbColumnType {
  ESN = 'esn',
  VIN = 'vin',
  LICENSE_PLATE = 'licensePlate',
  LAST_SUBMISSION = 'lastSubmission',
  EMAIL_ADDRESS = 'emailAddress',
  COUNTRY = 'country',
  STATE = 'state',
  SUBMISSION_STATUS = 'submissionStatus'
};

export interface CarbTabGridDataType {
  [CarbColumnType.ESN]: string;
  [CarbColumnType.VIN]: string;
  [CarbColumnType.LICENSE_PLATE]: string;
  [CarbColumnType.LAST_SUBMISSION]: string;
  [CarbColumnType.EMAIL_ADDRESS]: string;
  [CarbColumnType.COUNTRY]: string;
  [CarbColumnType.STATE]: string;
  [CarbColumnType.SUBMISSION_STATUS]: string;
};
